import { ChangeDetectorRef, Component } from '@angular/core';
import { Inspection } from '../../../shared/models';
import { PluginComponent } from '../../plugin.component';

@Component({
    templateUrl: './signature.component.html',
    standalone: false
})
export class InstallationSignaturePluginComponent {
  public config: any;
  public signatures: any[];
  public editRoute = ['installation', 'signature', 'edit'];

  constructor(private cdRef: ChangeDetectorRef) {}

  setConfig(config: any, inspection: Inspection, plugin: any) {
    this.config = config;
    this.initData();
    this.cdRef.detectChanges();
  }

  private initData() {
    this.signatures = this.config.Signatures;
  }
}
PluginComponent.plugins['installationsignature'] = InstallationSignaturePluginComponent;
